"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDownloadTerms = void 0;
__exportStar(require("./getKcContext"), exports);
__exportStar(require("./i18n"), exports);
var Terms_1 = require("./components/Terms");
Object.defineProperty(exports, "useDownloadTerms", { enumerable: true, get: function () { return Terms_1.useDownloadTerms; } });
__exportStar(require("./components/KcApp"), exports);
__exportStar(require("./components/KcProps"), exports);
__exportStar(require("./keycloakJsAdapter"), exports);
__exportStar(require("./useFormValidationSlice"), exports);
__exportStar(require("./tools/assert"), exports);
//# sourceMappingURL=index.js.map